import {CommonResponse, BaseRequestParams, GetSingleParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {ObjectGroupScheduleResponse, ObjectGroupSchedulesResponse} from "../models/response"

export const objectScheduleApi = {
    getSchedules(params?: GetObjectSchedules): Promise<CommonResponse<ObjectGroupSchedulesResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`ObjectSchedule${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getSchedule(params: GetSingleParamsType): Promise<CommonResponse<ObjectGroupScheduleResponse>> {
        const {id, controller} = params
        return instance.get(`ObjectSchedule/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    createSchedule(form: CreateObjectSchedule): Promise<CommonResponse<ObjectGroupScheduleResponse>> {
        const {controller, ...rest} = form
        return instance.post(`ObjectSchedule`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    changeSchedule(form: ChangeObjectSchedule): Promise<CommonResponse<ObjectGroupScheduleResponse>> {
        const {id, controller, ...rest} = form
        return instance.put(`ObjectSchedule/${id}`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    deleteSchedule(id: number): Promise<CommonResponse<any>> {
        return instance.delete(`ObjectSchedule/${id}`).then((res: AxiosResponse) => res.data)
    },
}

export type GetObjectSchedules = {
    idObject?: number
} & BaseRequestParams

export type CreateObjectSchedule = {
    idObject: number
    security: boolean
    comment: string
    days: Array<number>
    hour: number
    minute: number
} & BaseRequestParams

export type ChangeObjectSchedule = {
    id: number
} & CreateObjectSchedule